import { Email, Phone } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { t } from 'i18next';
import { EventParticipant } from 'src/modules/event/models/eventParticipant';
import { Member } from '../models/member';
import { MemberDetail } from './memberDetail';
import { MemberDetailBirthDate } from './memberDetailBirthDate';
import { MemberDetailGender } from './memberDetailGender';
import { MemberDetailLink } from './memberDetailLink';

type MemberDetailsSummaryProps = {
  member: Member | EventParticipant;
  showHeader?: boolean;
  small?: boolean;
};

export const MemberDetailsSummary = (props: MemberDetailsSummaryProps) => {
  const { member, showHeader = true, small = false } = props;

  return (
    member && (
      <>
        {showHeader && <Typography variant='h6'>{`${member.firstName} ${member.lastName}`}</Typography>}
        {'coAddress' in member && (
          <MemberDetail detail={member.coAddress ? `${t('member:tableHeaders.COAddress')} ${member.coAddress}` : undefined} small={small} />
        )}
        <MemberDetail detail={member.address} small={small} />
        <MemberDetail detail={member.addressOther} small={small} />
        <MemberDetail detail={member.postNr} small={small} />
        <MemberDetail detail={member.postAddress} small={small} />
        {'country' in member && <MemberDetail detail={member.country} small={small} />}
        <MemberDetailLink icon={<Email sx={{ mr: 1 }} />} linkPrefix='mailto:' details={[member.email || '']} small={small} />
        <MemberDetailLink icon={<Phone sx={{ mr: 1 }} />} linkPrefix='tel:' details={[member.phone || '', member.phoneOther || '']} small={small} />
        <MemberDetailBirthDate birthDate={member.birthDate} small={small} />
        {'sex' in member && <MemberDetailGender sex={member.sex} small={small} />}
      </>
    )
  );
};
